var _excluded = ["onSubmit", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js/instance/every";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { required, minLength, maxLength, email, pattern } from "../formValidators/index.js";
import createErrors from "../createErrors/index.js";
var schedulePreventable = function schedulePreventable(callback) {
  var timeoutId = _setTimeout(function () {
    callback();
  });
  return function () {
    clearTimeout(timeoutId);
  };
};
var getStaticPropsFromValidators = function getStaticPropsFromValidators(validators) {
  var props = {};
  _forEachInstanceProperty(validators).call(validators, function (validator) {
    _Object$assign(props, validator.staticProps || {});
  });
  return props;
};
var maybeCallFunction = function maybeCallFunction(prop) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return typeof prop === 'function' ? prop.apply(void 0, args) : prop;
};
var defaultSubTextOnInvalid = function defaultSubTextOnInvalid(_ref) {
  var errors = _ref.errors;
  return errors[0].data;
};
var Context = /*#__PURE__*/React.createContext({
  bindField: noop,
  unbindField: noop
});
var useRenderRef = function useRenderRef(val) {
  var ref = React.useRef(val);
  ref.current = val;
  return ref;
};
var normalizePatternArgs = function normalizePatternArgs(patternParam) {
  var args;
  if (_Array$isArray(patternParam)) {
    args = patternParam;
  } else if (_typeof(patternParam) === 'object' && !(patternParam instanceof RegExp)) {
    args = [patternParam.test, patternParam.patternName, patternParam.message];
  } else {
    args = [patternParam];
  }
  return args;
};
var Form = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$onSubmit = _ref2.onSubmit,
    onSubmit = _ref2$onSubmit === void 0 ? noop : _ref2$onSubmit,
    children = _ref2.children,
    restOfProps = _objectWithoutProperties(_ref2, _excluded);
  var fieldBindingsRef = React.useRef(new _Set());
  var bindField = function bindField(binding) {
    fieldBindingsRef.current.add(binding);
  };
  var unbindField = function unbindField(binding) {
    fieldBindingsRef.current["delete"](binding);
  };
  var handleLeavingOfAllFields = function handleLeavingOfAllFields() {
    var _context;
    _forEachInstanceProperty(_context = fieldBindingsRef.current).call(_context, function (fieldBinding) {
      fieldBinding.handleErrorsOnLeave();
    });
  };
  var handleSubmit = function handleSubmit(evt) {
    var _context2;
    /**
     * Prevent default needs to be the very first thing. See note #1 above.
     */
    evt.preventDefault();
    var valid = _everyInstanceProperty(_context2 = _toConsumableArray(fieldBindingsRef.current)).call(_context2, function (_ref3) {
      var errorsRef = _ref3.errorsRef;
      return errorsRef.current.length === 0;
    });
    var validate = function validate() {
      if (!valid) {
        var _context3;
        handleLeavingOfAllFields();
        var firstFocusableFieldWithErrorsBinding = _findInstanceProperty(_context3 = _toConsumableArray(fieldBindingsRef.current)).call(_context3, function (_ref4) {
          var errorsRef = _ref4.errorsRef,
            elementRef = _ref4.elementRef;
          return errorsRef.current.length > 0 && elementRef.current;
        });
        if (firstFocusableFieldWithErrorsBinding) {
          firstFocusableFieldWithErrorsBinding.elementRef.current.focus();
        }
      }
    };
    var preventValidation = schedulePreventable(validate);
    var pseudoEvent = {
      valid: valid,
      validate: validate,
      preventValidation: preventValidation
    };
    onSubmit(pseudoEvent, evt);
  };
  var context = {
    bindField: bindField,
    unbindField: unbindField
  };
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement("form", _extends({
    ref: ref,
    noValidate: true,
    onSubmit: handleSubmit
  }, restOfProps), children));
});
process.env.NODE_ENV !== "production" ? Form.propTypes = {
  /**
   * Called when form is submitted. Is given a custom event object that allows controlling validation behavior
   */
  onSubmit: PropTypes.func,
  /**
   * Form contents
   */
  children: PropTypes.node
} : void 0;
var useInput = function useInput(_ref5) {
  var defaultValue = _ref5.defaultValue,
    value = _ref5.value,
    name = _ref5.name,
    validations = _ref5.validations,
    ref = _ref5.ref,
    _ref5$onChange = _ref5.onChange,
    givenOnChange = _ref5$onChange === void 0 ? noop : _ref5$onChange,
    _ref5$onBlur = _ref5.onBlur,
    givenOnBlur = _ref5$onBlur === void 0 ? noop : _ref5$onBlur,
    _ref5$subText = _ref5.subText,
    subText = _ref5$subText === void 0 ? '' : _ref5$subText,
    _ref5$subTextOnValid = _ref5.subTextOnValid,
    subTextOnValid = _ref5$subTextOnValid === void 0 ? subText : _ref5$subTextOnValid,
    _ref5$subTextOnInvali = _ref5.subTextOnInvalid,
    subTextOnInvalid = _ref5$subTextOnInvali === void 0 ? defaultSubTextOnInvalid : _ref5$subTextOnInvali;
  var _React$useState = React.useState('neutral'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visualState = _React$useState2[0],
    setVisualState = _React$useState2[1];
  var visualStateRef = useRenderRef(visualState);
  var fallbackRef = React.useRef();
  var errorsRef = React.useRef([]);
  var finalElementRef = ref || fallbackRef;
  var isValueControlledRef = React.useRef(value !== undefined);
  var onChange = givenOnChange;
  var controlledOrUncontrolledValue;
  var handleErrorsOnChange = function handleErrorsOnChange() {
    if (visualStateRef.current === 'invalid' && errorsRef.current.length === 0) {
      setVisualState('valid');
    } else if (visualStateRef.current === 'valid' && errorsRef.current.length > 0) {
      setVisualState('invalid');
    }
  };
  var handleErrorsOnLeave = React.useCallback(function () {
    if (errorsRef.current.length > 0) {
      setVisualState('invalid');
    } else {
      setVisualState('neutral');
    }
  }, []);
  if (isValueControlledRef.current) {
    controlledOrUncontrolledValue = value;
  } else {
    /*
      Conditional call of react hooks is generally unsafe but
      it is completely safe here because it is dependent on a ref
      value that never changes
    */
    /* eslint-disable react-hooks/rules-of-hooks */
    var _React$useState3 = React.useState(defaultValue),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      uncontrolledValue = _React$useState4[0],
      setUncontrolledValue = _React$useState4[1];
    controlledOrUncontrolledValue = uncontrolledValue;
    onChange = React.useCallback(function (evt) {
      setUncontrolledValue(evt.target.value);
      givenOnChange(evt);
    }, [givenOnChange]);
  }
  errorsRef.current = createErrors(name, controlledOrUncontrolledValue, validations);
  handleErrorsOnChange();
  var onBlur = React.useCallback(function (evt) {
    if (!evt.currentTarget.contains(evt.relatedTarget)) {
      handleErrorsOnLeave();
    }
    givenOnBlur(evt);
  }, [handleErrorsOnLeave, givenOnBlur]);
  var finalProps = _objectSpread({
    ref: finalElementRef,
    defaultValue: defaultValue,
    value: value,
    name: name,
    'aria-invalid': visualState === 'invalid' ? 'true' : undefined,
    onBlur: onBlur,
    onChange: onChange
  }, getStaticPropsFromValidators(validations));
  var form = React.useContext(Context);
  var formRef = useRenderRef(form);
  React.useEffect(function () {
    var formBinding = {
      errorsRef: errorsRef,
      elementRef: finalElementRef,
      handleErrorsOnLeave: handleErrorsOnLeave
    };
    var dereferencedForm = formRef.current;
    dereferencedForm.bindField(formBinding);
    return function () {
      return dereferencedForm.unbindField(formBinding);
    };
  }, [finalElementRef, formRef, handleErrorsOnLeave]);
  var getSubtext = function getSubtext() {
    var errors = errorsRef.current;
    if (visualState === 'valid' && errors.length === 0) {
      return maybeCallFunction(subTextOnValid, {}, subText);
    }
    if (visualState === 'invalid' && errors.length > 0) {
      return maybeCallFunction(subTextOnInvalid, {
        errors: errors
      }, defaultSubTextOnInvalid({
        errors: errors
      }));
    }
    return maybeCallFunction(subText, {
      errors: errors
    }, '');
  };
  return [finalProps, {
    errors: errorsRef.current,
    state: visualState,
    subText: getSubtext()
  }];
};
export var Input = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var name = _ref6.name,
    value = _ref6.value,
    defaultValue = _ref6.defaultValue,
    validations = _ref6.validations,
    children = _ref6.children,
    onBlur = _ref6.onBlur,
    onChange = _ref6.onChange,
    subText = _ref6.subText,
    subTextOnValid = _ref6.subTextOnValid,
    subTextOnInvalid = _ref6.subTextOnInvalid,
    state = _ref6.state;
  var validationsAreBeingUsed = !!validations;
  var validationsEnabledRef = React.useRef(validationsAreBeingUsed);
  if (!validationsEnabledRef.current) {
    if (validationsAreBeingUsed) {
      process.env.NODE_ENV !== 'production' ? console.warn('Validations are being passed after being initialized as disabled. Probably means the component is being misused.') : void 0;
    }
    if (subTextOnValid || subTextOnInvalid) {
      process.env.NODE_ENV !== 'production' ? console.warn('Validations are disabled, yet `subTextOnValid` or `subTextOnInvalid` props were passed. These are only used when validations are enabled.') : void 0;
    }
    return children({
      onChange: onChange,
      onBlur: onBlur,
      name: name,
      ref: ref,
      value: value,
      defaultValue: defaultValue
    }, {
      state: state,
      subText: subText,
      errors: []
    });
  }
  if (state) {
    process.env.NODE_ENV !== 'production' ? console.warn('Validations are enabled. However, it is also receiving a `state` prop which no effect on the validation visual states. This possibly means this component is being misused.') : void 0;
  }
  if (!validationsAreBeingUsed) {
    process.env.NODE_ENV !== 'production' ? console.warn('Validations are being removed after being initialized as enabled. Probably means the component is being misused.') : void 0;
  }
  var finalValidations = React.useMemo(function () {
    var validationsFromConvenienceProp = function validationsFromConvenienceProp(validationValue) {
      var validationList = [];
      if (validationValue.required === true) {
        validationList.push(required());
      }
      if (validationValue.email === true) {
        validationList.push(email());
      }
      if (typeof validationValue.pattern !== 'undefined') {
        var args = normalizePatternArgs(validationValue.pattern);
        validationList.push(pattern.apply(void 0, _toConsumableArray(args)));
      }
      if (typeof validationValue.minLength === 'number') {
        validationList.push(minLength(validationValue.minLength));
      }
      if (typeof validationValue.maxLength === 'number') {
        validationList.push(maxLength(validationValue.maxLength));
      }
      return validationList;
    };
    var givenValidations = validations || [];
    var normalizedGivenValidations = _Array$isArray(givenValidations) ? givenValidations : [givenValidations];
    return _flatMapInstanceProperty(normalizedGivenValidations).call(normalizedGivenValidations, function (validation) {
      if (typeof validation.validate === 'function') {
        return validation;
      }
      return validationsFromConvenienceProp(validation);
    });
  }, [validations]);
  var _useInput = useInput({
      ref: ref,
      name: name,
      value: value,
      defaultValue: defaultValue,
      validations: finalValidations,
      onBlur: onBlur,
      onChange: onChange,
      subText: subText,
      subTextOnValid: subTextOnValid,
      subTextOnInvalid: subTextOnInvalid
    }),
    _useInput2 = _slicedToArray(_useInput, 2),
    props = _useInput2[0],
    data = _useInput2[1];
  return children(props, data);
});
var tupleType = function tupleType(typeCheckers) {
  return PropTypes.arrayOf(function (value, index) {
    var _typeCheckers$index;
    for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }
    return (_typeCheckers$index = typeCheckers[index]).call.apply(_typeCheckers$index, [PropTypes, value, index].concat(rest));
  });
};
Input.propTypes = {
  /**
   * Field name
   */
  name: PropTypes.string,
  /**
   * Value of input if you wish to enable controlled mode
   */
  value: PropTypes.string,
  /**
   * Default value for uncontrolled mode
   */
  defaultValue: PropTypes.string,
  /**
   * Validations to apply
   */
  validations: PropTypes.oneOfType([PropTypes.shape({
    required: PropTypes.bool,
    email: PropTypes.bool,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    pattern: PropTypes.oneOfType([tupleType([PropTypes.shape({
      test: PropTypes.func
    }), PropTypes.string]), PropTypes.shape({
      test: PropTypes.func
    }), PropTypes.shape({
      test: PropTypes.shape({
        test: PropTypes.func
      }),
      patternName: PropTypes.string,
      message: PropTypes.string
    })])
  }), PropTypes.shape({
    staticProps: PropTypes.shape(),
    name: PropTypes.string.isRequired,
    validate: PropTypes.func.isRequired
  }), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    required: PropTypes.bool,
    email: PropTypes.bool,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    pattern: PropTypes.oneOfType([tupleType([PropTypes.shape({
      test: PropTypes.func
    }), PropTypes.string]), PropTypes.shape({
      test: PropTypes.func
    })])
  }), PropTypes.shape({
    staticProps: PropTypes.shape(),
    name: PropTypes.string.isRequired,
    validate: PropTypes.func.isRequired
  })]))]),
  /**
   * Called on blur. Merged with onBlur provided by this component
   */
  onBlur: PropTypes.func,
  /**
   * Called on change. Merged with onChange provided by this component
   */
  onChange: PropTypes.func,
  /**
   * Sub text to render.
   * This is some generic messaging that the rendered component chooses how it should be rendered.
   * This is used when the visual state is `neutral` or when the visual state is `valid` and a
   * subTextOnValid was not provided. When a function is provided, current errors are passed to it.
   */
  subText: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * Sub text to render when visual state is valid.
   */
  subTextOnValid: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * Sub text to render when visual state is invalid. Defaults to rendering the first error.
   */
  subTextOnInvalid: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * Render function. Receives the generated props and the error state.
   *
   * ```
   * (nativeProps, { errors, state }) => React.node
   * ```
   */
  children: PropTypes.func.isRequired,
  /**
   * Force the state. Will only be used if validations are disabled.
   */
  state: PropTypes.oneOf(['valid', 'invalid', 'neutral'])
};
export default Form;